import React, { useEffect, useRef } from "react";
import { services } from "../../data";

const MiniServices = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const scrollStep = 2; // adjust the scrolling speed here
    let scrollAmount = 0;
    let scrollDirection = "right";
    let animationFrameId;

    const scroll = () => {
      if (scrollDirection === "right") {
        scrollAmount += scrollStep;
        container.scrollLeft = scrollAmount;

        // Change direction when reaching the end
        if (scrollAmount >= container.scrollWidth - container.clientWidth) {
          scrollDirection = "left";
        }
      } else {
        scrollAmount -= scrollStep;
        container.scrollLeft = scrollAmount;

        // Change direction when reaching the start
        if (scrollAmount <= 0) {
          scrollDirection = "right";
        }
      }

      animationFrameId = requestAnimationFrame(scroll);
    };

    const handleIntersection = (entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        // Start scrolling when the parent div is in view
        animationFrameId = requestAnimationFrame(scroll);
      } else {
        // Stop scrolling when the parent div is out of view
        cancelAnimationFrame(animationFrameId);
      }
    };

    const observer = new IntersectionObserver(handleIntersection, {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    });

    observer.observe(container);

    // Clean up the observer and animation frame when the component unmounts
    return () => {
      observer.unobserve(container);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);
  return (
    <div
      className="flex flex-nowrap items-center justify-start gap-4 no-scrollbar overflow-auto w-full relative h-[115px] bg-lightblue-1"
      ref={containerRef}
    >
      {services.map((service, index) => (
        <div
          className="flex flex-nowrap items-center gap-4 last-of-type:mr-5 first-of-type:ml-5 select-none mini-services"
          key={index}
        >
          <p className="text-xl md:text-2xl whitespace-nowrap">
            {service.name}
          </p>

          <p className="text-xl md:text-2xl whitespace-nowrap emoji-text">
            👷🏻👷🏻‍♀️
          </p>
        </div>
      ))}
    </div>
  );
};

export default MiniServices;
